export default {
  data() {
    return {};
  },
  methods: {},
  created() {
    let list = ['OBJLoader.js', 'FBXLoader.js', 'inflate.min.js', 'TGALoader.js', 'TrackballControls.js', 'PDBLoader.js', 'CSS2DRenderer.js', 'FBXLoader.js', 'MTLLoader.js', 'Detector.js', 'OrbitControls.js'];
    list.map(item => {
      let oScript = document.createElement('script');
      oScript.type = 'text/javascript';
      oScript.src = `js/3d/${item}`;
      document.body.appendChild(oScript);
    });
    let list2 = ['jquery-1.11.0.min.js', 'heartcode-canvasloader-min.js', 'threesixty.js'];
    list2.map(item => {
      let oScript = document.createElement('script');
      oScript.type = 'text/javascript';
      oScript.src = `js/360/${item}`;
      document.body.appendChild(oScript);
    });
    let oScript = document.createElement('script');
    oScript.type = 'text/javascript';
    oScript.src = `js/e-smart-zoom-jquery.min.js`;
    document.body.appendChild(oScript);
  },
  computed: {}
};